import { FormEditActions } from "@arelia-components/form/FormEditActions";
import ListFormItem from "@arelia-components/form/ListFormItem";
import { useHandleFormActions } from "@arelia-hooks/formikHooks";
import { Card, CardContent, CardHeader, List, TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import { ChangeEvent, useState } from "react";
import { EditForm } from "./AccountDetailsContainer";
import { formConfig } from "./constants";

type Props = {
  formik: FormikProps<EditForm>;
  handeChange: (name: keyof EditForm) => (event: ChangeEvent<HTMLInputElement>) => void;
};

export default function AccountDetailsPresenter({ formik, handeChange }: Props) {
  const [editing, setEditing] = useState(false);
  const formHandlers = useHandleFormActions<EditForm>(setEditing, formik);

  const readFieldRenderer = (field: keyof EditForm) => {
    const value = formik.values[field];
    return <Typography variant="subtitle2">{value}</Typography>;
  }

  const editFieldRenderer = (field: keyof EditForm) => {
    const value = formik.values[field];

    return <TextField
      value={value || ""}
      onChange={handeChange(field)}
      size="small"
      type="text"
      fullWidth
    />;
  }

  return (
    <Card sx={styles.card}>
      <CardHeader
        sx={styles.cardHeader}
        title="Customer info"
        action={<FormEditActions edit={editing} {...formHandlers} />}
      />
      <CardContent sx={{
        justifyContent: "flex-start"
      }}>
        <List>
          {formConfig.map(({ label, field }, index) => (
            <ListFormItem key={index} label={label}>
              {editing ? editFieldRenderer(field) : readFieldRenderer(field)}
            </ListFormItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

const styles = {
  card: {
    gridColumn: "span 8",
    gridRow: "span 8"
  },
  cardHeader: {
    marginBottom: "40px"
  },
  cardContent: {
    justifyContent: "flex-start"
  }
}